/* import __COLOCATED_TEMPLATE__ from './prescreener-renderer.hbs'; */
import { MODE_APPOINTMENT } from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import QuestionProcessor from 'client-portal/utils/prescreener/question-processor';
import styles from './prescreener-renderer.module.scss';

export default class RequestPrescreenerPrescreenerRenderer extends Component {
  @service currentPractice;
  @service prescreener;
  @service session;
  @service store;

  styles = styles;

  get clientType() {
    return this.args.clientType;
  }

  get model() {
    return this.args.model;
  }

  get formType() {
    return this.args?.formType || MODE_APPOINTMENT;
  }

  get excludeCategories() {
    return this.args.excludeCategories || [];
  }

  get includeCategories() {
    return this.args.includeCategories || [];
  }

  get forceValidation() {
    return this.prescreener.validation.forceValidation;
  }

  get numItems() {
    return this.args.numItems;
  }

  get startAt() {
    return this.args.startAt || 0;
  }

  get groupedQuestions() {
    return new QuestionProcessor(this.processorParams).groupedQuestions;
  }

  get processorParams() {
    let { prescreener, formType, includeCategories, excludeCategories, numItems, startAt } = this;

    return {
      prescreener,
      formType,
      includeCategories,
      excludeCategories,
      numItems,
      startAt,
    };
  }

  getAnswerModel(question) {
    return this.prescreener.validation.getValidatedAnswerModel(question, this.clientType);
  }

  @action
  onSetAndPropagateAnswers(question, value) {
    const validationModel = this.getAnswerModel(question);
    validationModel.set('value', value);

    this.args?.onChange?.(question, value);
    this.prescreener.updateAndValidateAnswer(question, value, this.clientType);
    if (!this.prescreener.preview.isPreview) {
      this.prescreener.processAnswersForClient(this.model, question, value);
    }
  }
}
